import React, { Fragment, useEffect } from 'react'
import { Modal } from '../../_EOS/Modal'
import { Typography } from '@mui/material'
import { DocumentPrint } from '../../UI/DocumentPrint/DocumentPrint'
import { Loading } from '../../UI'
import { apiCall, ApiConfig } from '../../../config/api'
import { useSnackbar } from '../../../hooks/useSnackbar'
import { generateErrorFromResponse } from '../../../utils/errorHelper'
import { ErrorResponse } from '../../../interfaces'

interface PrintModalState {
  workOrderId: number
  docPDF: string
  isLoading: boolean
}

interface PrintManifestModalProps {
  isOpen: boolean
  onClose: () => void
  workOrderId?: number
  modalState?: PrintModalState
  onStateChange?: (state: PrintModalState) => void
}

export const PrintManifestModal: React.FC<PrintManifestModalProps> = ({
  isOpen,
  onClose,
  workOrderId,
  modalState,
  onStateChange
}) => {
  const { openSnackBar } = useSnackbar()

  // Función para cargar el PDF del manifiesto
  const loadManifestPDF = async (workOrderId: number) => {
    if (!workOrderId || !onStateChange) return

    onStateChange({ workOrderId, docPDF: '', isLoading: true })

    try {
      const response = await apiCall(
        'GET',
        `${ApiConfig.DispatchOt}/${workOrderId}`
      )

      if (response.data && response.data.length > 0) {
        onStateChange({
          workOrderId,
          docPDF: response.data,
          isLoading: false
        })
      } else {
        openSnackBar('No se encontró el manifiesto para esta OT', false)
        onClose()
      }
    } catch (error) {
      const errorMessage = generateErrorFromResponse(
        error as { data: ErrorResponse }
      )
      openSnackBar(errorMessage, false)
      onClose()
    }
  }

  // Efecto para cargar el PDF cuando se abre el modal
  useEffect(() => {
    if (isOpen && workOrderId && !modalState?.docPDF) {
      loadManifestPDF(workOrderId)
    }
  }, [isOpen, workOrderId])

  return (
    <Fragment>
      <Modal onClose={onClose} open={isOpen} maxWidth='lg'>
        {modalState?.isLoading && <Loading />}
        {!modalState?.isLoading && modalState?.docPDF && (
          <Fragment>
            <Typography>
              {`Informe Manifiesto OT: ${modalState?.workOrderId}`}
            </Typography>
            <DocumentPrint documentPDF={modalState.docPDF} type='base64' />
          </Fragment>
        )}
      </Modal>
    </Fragment>
  )
}
